export interface IApiResponse<T = any> {
  message: string;
  status: boolean;
  status_code: number;
  data: T;
}

/** One file in an NFT's media gallery on the detail pages. */
export interface NftMediaItem {
  url: string;
  /** Unset until the file's type is known; the galleries render that as an image. */
  fileType?: string;
  /** The NFT's preview image, shown for HTML and 3D media. */
  preview?: string;
}

export interface IPagination {
  totalDocs: number;
  limit: number;
  totalPages: number;
  page: number;
  pagingCounter: number;
  hasPrevPage: boolean;
  hasNext_page: boolean;
  prevPage: number | null;
  nextPage: number | null;
}

export interface EmailPreferenceItem {
  key: string;
  name: string;
  value: boolean;
  description: string;
}

export interface EmailPreference {
  key: string;
  name: string;
  value: boolean;
  description: string;
  items: EmailPreferenceItem[];
}

export interface UserPreferencesPayload {
  user_id: string;
  preferences: EmailPreference[];
}

export interface UnsubscribeReason {
  value: string;
  label: string;
}

/** GET /unsubscribe — what the public unsubscribe page shows for an email link */
export interface UnsubscribeDetails {
  email: string;
  email_type: string;
  is_subscribed: boolean;
  reasons: UnsubscribeReason[];
}

export interface UnsubscribePayload {
  token: string;
  reason: string;
  custom_reason?: string;
}

export enum MethodTypes {
  REQ_LOAN = 'Request loan',
  UPDATE_LOAN = 'Updated loan request',
  ACCEPT_LOAN = 'Accepted loan',
  COUNTER_OFFER = 'Counter offered',
  RECOUNT_OFFER = 'Recounter offered',
  BORROW_RECOUNT_OFFER = 'Borrower recounter offered',
  CANCEL_LOAN = 'Cancelled loan',
  CREATE_SELL_ORDER = 'Created sell order',
  CANCEL_SELL_ORDER = 'Cancelled sell order',
  PURCHASE_SELL_ORDER = 'Purchased sell order',
  PURCHASE_PARTNER_ITEM = 'Purchased partner item',
  LOAN_REPAID = 'Loan repaid',
  FORECLOSE_LOAN = 'Foreclosed loan',
  SIGNUP = 'Signup',
  USER_BLOCK = 'User blocked',
  USER_UNBLOCK = 'User unblocked',
  UPDATE_USER = 'Updated user',
  DELETE_USER = 'Deleted user',
  ITEM_TRANSFER = 'Item transferred',
  CREATE_ITEMBID = 'Created item bid',
  EDIT_ITEMBID = 'Edited item bid',
  CANCEL_ITEMBID = 'Cancelled item bid',
  ACCEPT_ITEMBID = 'Accepted item bid',
  ITEM_MINTED = 'Item minted',
  PARTNER_COL_CREATED = 'Partner collection created',
  PARTNER_ITEM_CREATED = 'Partner item created',
  BURN_ITEM = 'Burned item',
  EMAIL_VERIFY = 'Email verified',
  GOOGLE_AUTH = 'Google auth',
  APPLY_AUTH = 'Apple auth',
  LOAN_DEFAULT = 'Loan defaulted',
  CREATE_ITEM_LOAN_BID = 'Created item loan bid',
  EDIT_ITEM_LOAN_BID = 'Edited item loan bid',
  ACCEPT_ITEM_LOAN_BID = 'Accepted item loan bid',
  CANCEL_ITEM_LOAN_BID = 'Cancelled item loan bid',
  BULK_MINT = 'Bulk minted',
  COUNTER_OFFER_OPEN_LOAN_BID = 'Counter offered open loan bid',
  CREATE_BULK_LOAN_BID = 'Created bulk loan bid',
  ACCEPT_BULK_LOAN_BID = 'Accepted bulk loan bid',
  CANCEL_BULK_LOAN_BID = 'Cancelled bulk loan bid',
  EDIT_BULK_LOAN_BID = 'Edited bulk loan bid',
  SELL_ORDER_CREATED = 'Sell order created',
  BUNDLE_PURCHASE = 'Bundle purchased sell order',
  ACCEPT_REFINANCE_LOAN = 'Accepted Refinance Loan'
}

export const LOAN_METHODS = new Set<string>([
    'request loan',
    'updated loan request',
    'accepted loan',
    'counter offer',
    'recounter offered',
    'borrower recounter offered',
    'cancel loan',
    'cancelled loan',
    'loan repaid',
    'foreclosed loan',
    'loan defaulted',
    'requested refinance loan',
    'accepted refinance loan',
    'updated refinance loan request',
    'repaid installment',
    'counter offered open loan bid',
    'loan sale request',
    'accepted loan sale request',
    'updated loan sale request'
]);

export const PRECIOUS_METAL_CATEGORY = ['gold', 'silver', 'platinum', 'palladium'];
export const POLTERSORRY = 'GAS TREASURY';
export const OPEN_LOAN_EVENT = 'OPEN_LOAN_OFFER_NEGOTIATION_UPDATE';

export interface ICollection {
  _id: string;
  collection_type: string;
  royalty_fee: string;
  name: string;
  symbol: string;
  base_url: string;
  owner_address: string;
  collection_owner_address: string;
  email: string[];
  cc_email: string[];
  attributes: string[];
  description: string;
  isLazyMint: boolean;
  chain_id: number;
  lazy_mint_urls: string[];
  status: number;
  tooltip_text_colour: string;
  tooltip_background_colour: string;
  is_deleted: boolean;
  createdAt: string;
  updatedAt: string;
  collection_address: string;
  transaction_hash: string;
}

export enum ShareType {
  NFT = 'nft',
  SYNDICATE = 'syndicate'
}

export enum CustodialType {
  custodial = 'custodial',
  nonCustodial = 'nonCustodial'
}
